import React from 'react';
import './index.css';
import logo from '../../Assets/images/helium-logo.png';

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <img src={logo} alt="Logo" className="logo" />
      </div>
    </header>
  );
};

export default Header;
